import { ReactNode, FC } from "react"
import { Grid, ListItemAvatar, ListItemText, useTheme } from "@mui/material"
import PaperBox from "components/PaperBox"
import { SkeletonCardAvatar } from "components/skeleton/SkeletonCardAvatar"
import { StyledPrimaryAvatar } from "shared/styled/Global"
import { StyledBlackText, StyledGreyText, StyledLink, StyledListItem } from "./DashboardCard.styled"
import { CircleIcon } from "components/icons/CircleIcon"

type ConditionalWrapperProps = {
  condition: boolean,
  wrapper: (children: ReactNode) => JSX.Element,
  children: ReactNode
}

const ConditionalWrapper: FC<ConditionalWrapperProps> = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : <>{children}</>

export type DashboardCardProps = {
  title: string,
  itemLength: number,
  quantityType: string,
  route?: any,
  icon?: any,
  img?: string,
  status?: number,
  iconColor?: string,
  backgroundColor?: string,
  xlGridSize?: number
}

export const DashboardCard: FC<DashboardCardProps> = ({
  title,
  itemLength,
  quantityType,
  route,
  icon,
  img,
  status,
  iconColor,
  backgroundColor,
  xlGridSize
}) => {
  const theme = useTheme()

  return (
    <Grid item xs={12} md={12} lg={4} xl={xlGridSize ?? 4} sx={{ pt: "0px !important" }}>
      {status === 1 && <SkeletonCardAvatar />}
      {status === 2 && (
        <ConditionalWrapper
          condition={!!route}
          wrapper={(children) => (
            <StyledLink to={route}>
              {children}
            </StyledLink>
          )}>
          <PaperBox sx={{ p: "20px", borderRadius: "12px", mt: { xs: 2, lg: 0 } }} >
            <StyledListItem disableGutters>
              <ListItemAvatar>
                {img ? (
                  <StyledPrimaryAvatar
                    aria-label="icon"
                    sx={{ width: "40px", height: "40px", marginRight: "15px" }}>
                    <img height="16px" width="16px" src={img} alt={title} />
                  </StyledPrimaryAvatar>
                ) : (
                  <CircleIcon
                    backgroundColor={backgroundColor}
                    color={iconColor}
                    icon={icon}
                    size="sm"
                    sx={{ marginRight: "15px" }}
                  />
                )}
              </ListItemAvatar>

              <ListItemText sx={{ p: 0 }}>
                <Grid container justifyContent="space-between" alignItems="center">
                  <Grid item>
                    <StyledGreyText color="secondary" variant="bodyMedium">
                      {title}
                    </StyledGreyText>

                    <StyledBlackText variant="h1">
                      {itemLength} {quantityType}
                    </StyledBlackText>
                  </Grid>
                </Grid>
              </ListItemText>
            </StyledListItem>
          </PaperBox>
        </ConditionalWrapper>
      )}
    </Grid>
  )
}
